<template>
    <button v-if="displayButton" @click="scrollToTop" class="scroll-to-top-button">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="35px" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="35px" xml:space="preserve" class="scroll-to-top-button__svg">
            <path d="M128.4,189.3L233.4,89c5.8-6,13.7-9,22.4-9c8.7,0,16.5,3,22.4,9l105.4,100.3c12.5,11.9,12.5,31.3,0,43.2  c-12.5,11.9-32.7,11.9-45.2,0L288,184.4v217c0,16.9-14.3,30.6-32,30.6c-17.7,0-32-13.7-32-30.6v-217l-50.4,48.2  c-12.5,11.9-32.7,11.9-45.2,0C115.9,220.6,115.9,201.3,128.4,189.3z"/>
        </svg>
    </button>
</template>

<script>
    export default {
        name: 'scroll-to-top-button',
        data() {
            return {
                displayButton: false
            }
        },
        mounted() {
            window.addEventListener("scroll", () => {
                this.isFooterInViewport();
            });
        },
        methods: {
            isFooterInViewport() {
                let footer = document.querySelector('.app-footer');
                let bounding = footer.getBoundingClientRect();
                let footerHeight = footer.offsetHeight;
                let footerWidth = footer.offsetWidth;

                if (bounding.top >= -footerHeight
                    && bounding.left >= -footerWidth
                    && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + footerWidth
                    && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + footerHeight) {

                    this.displayButton = true;
                } else {
                    this.displayButton = false;
                }
            },
            scrollToTop() {
                window.scrollTo({top: 0, behavior: 'smooth'});
            }
        }
    }
</script>